<template>
  <ButtonPrimary @click="openIntercom">
    <AppIcon
      class="mr-2"
      name="solid-bolt"
    />
    <slot>{{ $t('upsell.contact_us') }}</slot>
  </ButtonPrimary>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { mapGetters } from '@/store/lib/vue3helpers.js';
import useSupportChat from '@/composables/useSupportChat';

const props = defineProps({
  feature: { type: String, required: true },
});

const { t } = useI18n();
const { current_profile } = mapGetters(['current_profile']);
const { openSupportChat } = useSupportChat();

function openIntercom() {
  const message = t(`upsell.${props.feature}.intercom`, { name: current_profile.value.attributes.name });
  openSupportChat(message);
}
</script>
